<template>
  <SimpleComparisonRow
    class="simple-comparison-row__rank"
    label="Ranking"
    :data="data"
    :number-products="numberProducts"
    :index="index"
    :no-highlight="$parent.noHighlight"
  >
    <template v-slot="{ columnData }">
      <div class="similar-comparison-data-body">
        <template v-if="columnData && columnData.value && Array.isArray(columnData.value)" v-for="valueItem in columnData.value">
          {{ '#' + valueItem.value.value }}
          <span
            class="label"
            :class="valueItem.value.percentile > 0 ? 'label-warning' : 'label-default'"
          >
            {{ percentileText(valueItem.value.percentile) }}
          </span>
        </template>
        <span v-else>{{ $t('generic.n_a') }}</span>
      </div>
    </template>
  </SimpleComparisonRow>
</template>

<script>
import SimpleComparisonRow from '@/components/shared/simple-comparison/SimpleComparisonRow';

export default {
  components: {
    SimpleComparisonRow,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    numberProducts: {
      type: Number,
      default: 4,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    percentileText(percentile) {
      return percentile > 0
        ? this.$t('partials.top_percent', { percent: percentile })
        : this.$t('partials.bottom_percent', { percent: Math.abs(percentile) });
    },
  },
};
</script>

<style lang="scss" scoped>
.simple-comparison-row__rank {
  .similar-comparison-data-body {
    display: flex;
    align-items: center;
    .label {
      padding: 0.3em 0.6em 0.3em;
      margin-left: $small_gap;
    }
  }
}
</style>
